import System from "src/helper/system";

class Auth {
    static SAVE_USER_PREFRENCE_URL = System.getBaseUrl() + `/api/user/saveUserPreference`;
    static REGISTER_USER_URL = System.getBaseUrl() + `/api/user/adduser`;
}

export default Auth;